module.exports = __webpack_public_path__ + "img/Cancel2.de35d1ec.svg";